// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/mic-off.js';

import { paths } from '../generated/mic-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('mic-off', Original, paths);
